import { render } from "./devHome.vue?vue&type=template&id=021aad3f"
import script from "./devHome.vue?vue&type=script&lang=js"
export * from "./devHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__